import { useMemo } from 'react';
import { useMediaQuery } from '@aimsos/hooks';
import {
  FILTERS_BAR_BREAKPOINTS,
  FILTERS_BAR_SLOT_LIMITS,
} from './filtersResponsive.js';

/**
 * Cuántos `FilterSlot` pueden mostrarse en la barra según el viewport actual.
 *
 * @returns {number} 0–4
 */
export function useFiltersBarSlotLimit() {
  const isAtLeastDesktop = useMediaQuery(
    `(min-width: ${FILTERS_BAR_BREAKPOINTS.desktop}px)`,
  );

  return useMemo(
    () =>
      isAtLeastDesktop
        ? FILTERS_BAR_SLOT_LIMITS.desktop
        : FILTERS_BAR_SLOT_LIMITS.compact,
    [isAtLeastDesktop],
  );
}
